import React, { useState, useEffect } from 'react';
import { useAnalytics } from '../hooks/useAnalytics';
import { analyticsConfig } from '../config/analytics.config';
import { logger } from '../utils/logger';

export const CookieConsent: React.FC = () => {
  const { hasConsent, setConsent } = useAnalytics();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Don't show banner if consent not required
    if (!analyticsConfig.privacy.requireConsent) {
      logger.debug('🍪 Cookie Consent: Not required, skipping banner');
      return;
    }
    
    // Check if user has already made a choice
    const hasStoredConsent = localStorage.getItem('festprep_analytics_consent');
    logger.debug('🍪 Cookie Consent: Checking stored consent:', hasStoredConsent);
    logger.debug('🍪 Cookie Consent: Component mounted');
    if (!hasStoredConsent) {
      logger.debug('🍪 Cookie Consent: No consent found, showing banner');
      setShowBanner(true);
      // Force a re-render to ensure visibility
      setTimeout(() => {
        const banner = document.querySelector('[data-cookie-banner]');
        if (banner) {
          logger.debug('🍪 Cookie Consent: Banner element found in DOM');
        } else {
          logger.debug('🍪 Cookie Consent: Banner element NOT found in DOM');
        }
      }, 100);
    }
  }, []);

  const handleAccept = () => {
    setConsent(true);
    setShowBanner(false);
  };

  const handleDecline = () => {
    setConsent(false);
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div 
      data-cookie-banner="true"
      className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-4 shadow-lg z-50"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#111827',
        color: 'white',
        padding: '1rem',
        boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
        zIndex: 9999,
        width: '100%',
        display: 'block'
      }}
    >
      <div className="container mx-auto max-w-6xl" style={{ maxWidth: '1152px', margin: '0 auto' }}>
        <div className="flex flex-col md:flex-row items-center justify-between gap-4" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem' }}>
          <div className="flex-1" style={{ flex: 1 }}>
            <p className="text-sm" style={{ fontSize: '0.875rem' }}>
              We use cookies and analytics to improve your experience on our site. 
              This helps us understand how you use FestPrep and make it better for everyone.
            </p>
          </div>
          <div className="flex gap-3" style={{ display: 'flex', gap: '0.75rem' }}>
            <button
              onClick={handleDecline}
              className="px-4 py-2 text-sm border border-gray-500 rounded hover:bg-gray-800 transition-colors"
              style={{
                padding: '0.5rem 1rem',
                fontSize: '0.875rem',
                border: '1px solid #6b7280',
                borderRadius: '0.25rem',
                backgroundColor: 'transparent',
                color: 'white',
                cursor: 'pointer'
              }}
            >
              Decline
            </button>
            <button
              onClick={handleAccept}
              className="px-4 py-2 text-sm bg-green-600 rounded hover:bg-green-700 transition-colors"
              style={{
                padding: '0.5rem 1rem',
                fontSize: '0.875rem',
                backgroundColor: '#059669',
                borderRadius: '0.25rem',
                color: 'white',
                border: 'none',
                cursor: 'pointer'
              }}
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};